// Libraries
import { action, computed } from "mobx";

// Core
import { ViewModelBase } from "Core/ViewModels";
import { FieldType, isEmptyOrWhitespace } from "Core/Utils/Utils";

export class QuoteItemViewModel extends ViewModelBase {
    constructor(model: any) {
        super(model);
    }

    // #region Quote Item Properties

    @computed
    public get canEditUnits(): boolean {
        return this.model.canEditUnits;
    }

    @computed
    public get product(): string {
        return isEmptyOrWhitespace(this.model.variantName) ? this.model.productName : `${this.model.productName} (${this.model.variantName})`;
    }

    @computed
    public get stockUnit(): string {
        return this.model.productStackUnit;
    }

    @computed
    public get unitPrice(): string {
        let retVal: string = "POA";
        if (this.model.unitPrice >= 0) {
            retVal = `£${this.model.unitPrice.toFixed(2)}`;
        }
        return retVal;
    }

    @computed
    public get units(): number {
        return this.model.units;
    }

    @computed
    public get price(): string {
        let retVal: string = "POA";
        if (this.model.unitPrice >= 0) {
            retVal = `£${(this.model.unitPrice * this.model.units).toFixed(2)}`;
        }
        return retVal;
    }

    @action
    public setUnits = (value: number) => {
        this.model.units = value;
    };

    @action
    public setUnitsZero = () => {
        this.model.units = 0;
    };

    // #endregiopn Quote Item Properties

    // #region Viewmodel Boilerplate

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public isFieldValid(fieldName: keyof FieldType<any>): boolean {
        return true;
    }

    // #endregion Viewmodel Boilerplate
}
